import { render, staticRenderFns } from "./Grafico4.vue?vue&type=template&id=70f486e1&"
import script from "./Grafico4.vue?vue&type=script&lang=js&"
export * from "./Grafico4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports